module.exports = __webpack_public_path__ + "8d23660f6a08058dffb56ffc7c51002a.png";